/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ios_SubInputs */

const en__field_ios_sub = /** @type {(inputs: _Field_Ios_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS Subscription`)
};

/**
* | output |
* | --- |
* | "iOS Subscription" |
*
* @param {_Field_Ios_SubInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_ios_sub = /** @type {((inputs?: _Field_Ios_SubInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ios_SubInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_ios_sub(inputs)
});